import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddJanataDarbar = () => {
  const navigate = useNavigate();
  const initialState = {
    title: "",
    organizer: "",
    date: "",
    start_time: "",
    end_time: "",
    venue: "",
    ward_id: "",
    address: "",
    description: "",
    banner: null,
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [ward, setWard] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadWard = async () => {
    try {
      const response = await apiFetch("leader_admin/get_ward_by_user_id");
      if (response.ward) {
        setWard(response.ward);
        setFormData((prev) => ({ ...prev, ward_id: response.ward.ward_id }));
      }
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    loadWard();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "banner") {
      setFormData({ ...formData, banner: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.title.trim()) {
      newErrors.title = "दरबार शीर्षक आवश्यक आहे (Darbar Title is required)";
    }
    if (!formData.organizer.trim()) {
      newErrors.organizer = "आयोजकाचे नाव आवश्यक आहे (Organizer Name is required)";
    }
    if (!formData.date) {
      newErrors.date = "दिनांक आवश्यक आहे (Date is required)";
    }
    if (!formData.start_time) {
      newErrors.start_time = "सुरुवातीची वेळ आवश्यक आहे (Start Time is required)";
    }
    if (!formData.end_time) {
      newErrors.end_time = "समाप्तीची वेळ आवश्यक आहे (End Time is required)";
    }
    if (!formData.venue.trim()) {
      newErrors.venue = "स्थळाचे नाव आवश्यक आहे (Venue Name is required)";
    }
    if (!formData.address.trim()) {
      newErrors.address = "पूर्ण पत्ता आवश्यक आहे (Full Address is required)";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null) {
          data.append(key, formData[key]);
        }
      });

      await apiFetch("leader_admin/add_janta_darbar", {
        method: "POST",
        body: data,
      });

      alert("जनता दरबार यशस्वीरीत्या जतन झाला (Janata Darbar saved successfully)");
      navigate("/jantadarbar_list");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                🏛 जनता दरबार जोडा (Add Janata Darbar)
              </h4>
              <small className="text-white-50">
                Create a new Janata Darbar event for your ward
              </small>
            </div>
          </div>

          <Link to="/jantadarbar_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Darbar List
          </Link>
        </div>

        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">वार्ड (Ward)</label>
                  <input
                    type="text"
                    className="form-control"
                    value={
                      ward
                        ? `${ward.ward_name} (वार्ड क्र. / Ward No.: ${ward.ward_number})`
                        : "लोड होत आहे... (Loading...)"
                    }
                    disabled
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    दरबार शीर्षक (Darbar Title) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.title ? "is-invalid" : ""}`}
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                  />
                  {errors.title && (
                    <small className="text-danger d-block mt-1">{errors.title}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    आयोजकाचे नाव (Organizer Name) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.organizer ? "is-invalid" : ""}`}
                    name="organizer"
                    value={formData.organizer}
                    onChange={handleChange}
                  />
                  {errors.organizer && (
                    <small className="text-danger d-block mt-1">{errors.organizer}</small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">
                    दिनांक (Date) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className={`form-control ${errors.date ? "is-invalid" : ""}`}
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                  />
                  {errors.date && (
                    <small className="text-danger d-block mt-1">{errors.date}</small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">
                    सुरुवातीची वेळ (Start Time) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="time"
                    className={`form-control ${errors.start_time ? "is-invalid" : ""}`}
                    name="start_time"
                    value={formData.start_time}
                    onChange={handleChange}
                  />
                  {errors.start_time && (
                    <small className="text-danger d-block mt-1">{errors.start_time}</small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">
                    समाप्तीची वेळ (End Time) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="time"
                    className={`form-control ${errors.end_time ? "is-invalid" : ""}`}
                    name="end_time"
                    value={formData.end_time}
                    onChange={handleChange}
                  />
                  {errors.end_time && (
                    <small className="text-danger d-block mt-1">{errors.end_time}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    स्थळाचे नाव (Venue Name) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.venue ? "is-invalid" : ""}`}
                    name="venue"
                    value={formData.venue}
                    onChange={handleChange}
                  />
                  {errors.venue && (
                    <small className="text-danger d-block mt-1">{errors.venue}</small>
                  )}
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">
                    पूर्ण पत्ता (Full Address) <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className={`form-control ${errors.address ? "is-invalid" : ""}`}
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                  {errors.address && (
                    <small className="text-danger d-block mt-1">{errors.address}</small>
                  )}
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">वर्णन (Description)</label>
                  <textarea
                    className="form-control"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">बॅनर अपलोड करा (Upload Banner)</label>
                  <input type="file" className="form-control" name="banner" onChange={handleChange} />
                </div>
              </div>

              <div className="mt-4 text-end">
                <button className="btn btn-primary px-5" disabled={loading} style={{ fontSize: "0.85rem" }}>
                  {loading ? "जतन करत आहे... (Saving...)" : "दरबार जतन करा (Save Darbar)"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddJanataDarbar;
